(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4050],{

/***/ 7182:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[category]",
      function () {
        return __webpack_require__(94070);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);

var ArticleImageModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, imageSrc = param.imageSrc;
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50",
        onClick: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-full p-4 pt-10 bg-white rounded-lg shadow-lg max-w-8xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "absolute z-50 text-2xl top-2 right-2",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "text-4xl font-bold ri-close-line"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: imageSrc,
                    className: "max-h-[90vh] w-auto object-contain mx-auto",
                    alt: "Selected"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleImageModal);


/***/ }),

/***/ 98982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);


var SocialMediaContent = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "help"
    ]).t;
    var socialMedia = [
        {
            id: 1,
            icon: "ri-instagram-line",
            link: "https://www.instagram.com/makdos.cloud/",
            name: "makdos.cloud"
        },
        {
            id: 2,
            icon: "ri-facebook-circle-line",
            link: "https://www.facebook.com/makdostech",
            name: "makdos"
        },
        {
            id: 3,
            icon: "ri-linkedin-line",
            link: "https://tr.linkedin.com/company/makdos",
            name: "makdos"
        },
        {
            id: 4,
            icon: "ri-youtube-line",
            link: "https://www.youtube.com/@MakdosCloud",
            name: "MakdosCloud"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "hidden p-6 bg-white rounded-md lg:block",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: "pb-4 text-2xl font-semibold",
                children: t("help:socialMedia")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-textGray",
                children: t("help:followSocialMedia")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pt-5",
                children: socialMedia.map(function(media, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center justify-between pb-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "text-2xl text-black ".concat(media.icon)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: media.link,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-textGray",
                                        children: media.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-textGray px-4 py-2.5 rounded-full border-2 border-buttonBg cursor-pointer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: media.link,
                                    target: "_blank",
                                    children: t("help:follow")
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialMediaContent);


/***/ }),

/***/ 81681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13786);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



var SubjectsComponent = function(param) {
    var articleForCategory = param.articleForCategory, locale = param.locale;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "pb-8 text-2xl font-semibold text-black",
                children: t("help:subjects")
            }),
            articleForCategory.map(function(item, index) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pb-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/".concat(locale === "tr" ? "yardim" : "help", "/").concat(item === null || item === void 0 ? void 0 : item.category.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-textGray2 hover:text-orange-500",
                                children: item === null || item === void 0 ? void 0 : item.category.title
                            })
                        }),
                        item.article.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pt-2 pl-8",
                            children: item.article.map(function(article, subIndex) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/".concat(locale === "tr" ? "yardim" : "help", "/").concat(item === null || item === void 0 ? void 0 : item.category.slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-2 text-textGray2 hover:text-orange-500",
                                        children: [
                                            " ",
                                            article.title
                                        ]
                                    })
                                }, subIndex);
                            })
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SubjectsComponent);


/***/ }),

/***/ 94070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59072);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _components_Help_SocialMediaContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98982);
/* harmony import */ var _components_Help_SubjectsComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81681);
/* harmony import */ var layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4967);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70649);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13786);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50959);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66264);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63498);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var store_GlobalStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36345);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93834);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_Help_ArticleImageModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90215);













var index = function(param) {
    var articleForCategory = param.articleForCategory, categoryDetail = param.categoryDetail, locale = param.locale;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)([
        "common",
        "nav",
        "help"
    ]).t;
    var ref26 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,store_GlobalStore__WEBPACK_IMPORTED_MODULE_9__/* .useGlobalStore */ .s)(function(state) {
        return [
            state.setOtherCategoriesWiki
        ];
    }), 1), setOtherCategoriesWiki = ref26[0];
    var articleRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var defaultNoImage = "/noImageWiki.png";
    var ref27 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), heading = ref27[0], setHeading = ref27[1];
    var ref28 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), selectedImage = ref28[0], setSelectedImage = ref28[1];
    var ref29 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isModalOpen = ref29[0], setIsModalOpen = ref29[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setOtherCategoriesWiki(categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.other_categories);
        if (articleRef.current) {
            var emptyParagraphs = articleRef.current.querySelectorAll("p:empty");
            emptyParagraphs.forEach(function(p) {
                p.style.display = "block";
                p.style.height = "16px";
                p.style.margin = "8px 0";
            });
            var titleStyle = articleRef.current.querySelectorAll("h3");
            titleStyle.forEach(function(h3) {
                h3.style.fontWeight = "bold";
                h3.style.fontSize = "24px";
            });
            var contentsHeading = Array.from(titleStyle).map(function(title, index) {
                return {
                    id: "heading-".concat(index),
                    title: title.textContent,
                    element: title
                };
            });
            contentsHeading.forEach(function(heading) {
                heading.element.id = heading.id;
            });
            setHeading(contentsHeading);
            var imageTags = Array.from(articleRef.current.querySelectorAll("img"));
            imageTags === null || imageTags === void 0 ? void 0 : imageTags.forEach(function(img) {
                img.style.cursor = "pointer";
                img.addEventListener("click", function() {
                    setSelectedImage(img.src);
                    setIsModalOpen(true);
                });
            });
            return function() {
                imageTags.forEach(function(img) {
                    img.removeEventListener("click", function() {
                        setSelectedImage(img.src);
                        setIsModalOpen(true);
                    });
                });
            };
        }
    }, [
        categoryDetail
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_10___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: (ref = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref === void 0 ? void 0 : ref.meta_title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: (ref1 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref1 === void 0 ? void 0 : ref1.meta_description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: (ref2 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref2 === void 0 ? void 0 : ref2.meta_title
                    }, "title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: (ref3 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref3 === void 0 ? void 0 : ref3.meta_description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: ((ref4 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref4 === void 0 ? void 0 : ref4.image) ? "https://api-web.makdos.com/" + ((ref5 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref5 === void 0 ? void 0 : ref5.image) : "https://makdos.com/headerLogo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full bg-slate-100 lg:bg-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[228px] lg:!h-[264px] items-center justify-center flex bg-makdosYellow "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container z-30 mx-auto -mt-40 lg:-mt-72 lg:py-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid lg:gap-6 lg:grid-cols-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "order-last space-y-6 lg:block lg:col-span-3 lg:order-first",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-1 p-2 rounded-md cursor-pointer lg:p-3 bg-makdosSecondaryGray lg:bg-white",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mx-0 bg-white rounded-md",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Help_SubjectsComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    articleForCategory: articleForCategory,
                                                    locale: locale
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "hidden lg:block",
                                            children: ((ref6 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref6 === void 0 ? void 0 : ref6.highlights.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                href: "".concat((ref7 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.highlights) === null || ref8 === void 0 ? void 0 : ref8.link),
                                                as: "".concat((ref9 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.highlights) === null || ref10 === void 0 ? void 0 : ref10.link),
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    src: "".concat(((ref11 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.highlights) === null || ref12 === void 0 ? void 0 : ref12.img) ? "https://api-web.makdos.com/" + ((ref13 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.highlights) === null || ref14 === void 0 ? void 0 : ref14.img) : defaultNoImage),
                                                    width: 398,
                                                    height: 518,
                                                    alt: "".concat((ref15 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.highlights) === null || ref16 === void 0 ? void 0 : ref16.image_alt_text),
                                                    title: "".concat((ref17 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.highlights) === null || ref18 === void 0 ? void 0 : ref18.image_title),
                                                    className: "cursor-pointer",
                                                    onError: function(param) {
                                                        var currentTarget = param.currentTarget;
                                                        currentTarget.onerror = null;
                                                        currentTarget.src = defaultNoImage;
                                                        currentTarget.srcset = defaultNoImage;
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "order-first col-span-1 lg:mx-0 lg:col-span-6 lg:order-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-span-1 p-4 bg-white rounded-md lg:col-span-6 lg:p-7",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "relative w-full h-[211px] lg:h-[425px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    src: ((ref19 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref19 === void 0 ? void 0 : ref19.image) ? "https://api-web.makdos.com/" + ((ref20 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref20 === void 0 ? void 0 : ref20.image) : defaultNoImage,
                                                    layout: "fill",
                                                    alt: (ref21 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref21 === void 0 ? void 0 : ref21.image_description,
                                                    title: (ref22 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref22 === void 0 ? void 0 : ref22.image_title,
                                                    onError: function(param) {
                                                        var currentTarget = param.currentTarget;
                                                        currentTarget.onerror = null;
                                                        currentTarget.src = defaultNoImage;
                                                        currentTarget.srcset = defaultNoImage;
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    className: "pt-4 text-4xl font-semibold text-black",
                                                    children: (ref23 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref23 === void 0 ? void 0 : ref23.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pt-4 font-bold text-black",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: (ref24 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref24 === void 0 ? void 0 : ref24.description
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pt-4 whitespace-pre-line article-content",
                                                ref: articleRef,
                                                dangerouslySetInnerHTML: {
                                                    __html: (ref25 = categoryDetail === null || categoryDetail === void 0 ? void 0 : categoryDetail.category[0]) === null || ref25 === void 0 ? void 0 : ref25.message
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "hidden lg:block lg:space-y-6 lg:order-last lg:col-span-3",
                                    children: [
                                        heading && heading.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "p-6 bg-white rounded-md",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    className: "flex justify-between text-xl font-semibold",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: t("help:contents")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: "mt-4 space-y-2",
                                                    children: heading.map(function(head) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            className: "py-4 border-b border-buttonBg",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "#".concat(head.id),
                                                                className: "text-textGray",
                                                                onClick: function(e) {
                                                                    e.preventDefault();
                                                                    var element = document.getElementById(head.id);
                                                                    if (element) {
                                                                        var offset = 105;
                                                                        var elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                                                        var offsetPosition = elementPosition - offset;
                                                                        window.scrollTo({
                                                                            top: offsetPosition,
                                                                            behavior: "smooth"
                                                                        });
                                                                    }
                                                                },
                                                                children: head.title
                                                            })
                                                        }, head.id);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Help_SocialMediaContent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Help_ArticleImageModal__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                isOpen: isModalOpen,
                onClose: function() {
                    return setIsModalOpen(false);
                },
                imageSrc: selectedImage
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2658,4967,9774,2888,179], function() { return __webpack_exec__(7182); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);